<template>
<!--  <page-banner :page-number="3"/>-->
  <crumbs />
  <div class="mainContainer">
    <show-content :detail="detail"/>
    <recommended-news :recommendedList="recommendedNewsList" />
  </div>
</template>

<script setup>
import {getNewsDetail, getRecommendedNews} from "../../../apis/news";
import Crumbs from "../../../components/crumbs";

const Route = useRoute();
// 新闻id
const newsId = ref(Route.params.id);
// 新闻详情
const detail = ref({});
// 推荐新闻列表
const recommendedNewsList = ref([]);

// 获取详情
const newsDetail = await useAsyncData("getNewsDetail", () => getNewsDetail(newsId));
const data = newsDetail.data
if (data.value.code !== 200) {
  throw createError({statusCode: data.value.code, statusMessage: encodeURIComponent("新闻详情")})
} else {
  detail.value = data.value.data
}

// 获取推荐新闻
const recommendedNewsRes = await useAsyncData("getRecommendedNews", () => getRecommendedNews(newsId));
if (recommendedNewsRes.data.value.code !== 200) {
  throw createError({statusCode: recommendedNewsRes.data.value.code, statusMessage: encodeURIComponent("新闻详情")})
} else {
  recommendedNewsList.value = recommendedNewsRes.data.value.data
}
// 设置TDK
useHead({
  title: `${detail.value?.newsTitle} - 郑州路桥建设投资集团有限公司`,
})
</script>

<style scoped lang="scss">
.mainContainer{
  display: flex;
  align-items: flex-start;
}
</style>